export default __webpack_public_path__ + "static/media/slider_6-sm@2x.30b732ec.webp";